import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FiArrowLeft, FiMail } from "react-icons/fi";
import { LuPhone } from "react-icons/lu";

const T = {
  bg: "#0c0c0c",
  card: "#181818",
  lime: "#d4ff00",
  white: "#f0ede6",
  muted: "#525252",
  border: "rgba(255,255,255,0.07)",
};

const CONTACT_EMAIL = "info@pchinojosa.com";
const CONTACT_PHONE = "957143022";

export default function PlatformContactPage() {
  return (
    <div style={{ background: T.bg, minHeight: "100vh", color: T.white, padding: "40px 20px 80px" }}>
      <div style={{ maxWidth: 560, margin: "0 auto" }}>
        <Link
          to="/"
          style={{ display: "inline-flex", alignItems: "center", gap: 8, marginBottom: 32, color: T.muted, fontSize: "0.85rem", textDecoration: "none" }}
        >
          <FiArrowLeft size={16} /> Volver
        </Link>

        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>
          <h1 style={{ fontWeight: 800, fontSize: "2rem", marginBottom: 10 }}>Contacto</h1>
          <p style={{ color: T.muted, fontSize: "0.9rem", lineHeight: 1.6, marginBottom: 32 }}>
            PulseTicket es la plataforma de venta de entradas donde cada promotor gestiona sus propios
            eventos. Para dudas sobre un pedido, un evento o un reembolso concretos, contacta primero
            con el promotor del evento (sus datos aparecen en la tienda y en el email de confirmación).
            Para cualquier otra consulta sobre la plataforma, puedes escribirnos aquí:
          </p>

          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              style={{ display: "flex", alignItems: "center", gap: 12, padding: 16, borderRadius: 14,
                background: T.card, border: `1px solid ${T.border}`, textDecoration: "none", color: T.white }}
            >
              <FiMail size={18} color={T.lime} />
              <div>
                <p style={{ fontSize: "0.7rem", color: T.muted, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 2 }}>Email</p>
                <p style={{ fontSize: "0.9rem" }}>{CONTACT_EMAIL}</p>
              </div>
            </a>

            <a
              href={`tel:${CONTACT_PHONE}`}
              style={{ display: "flex", alignItems: "center", gap: 12, padding: 16, borderRadius: 14,
                background: T.card, border: `1px solid ${T.border}`, textDecoration: "none", color: T.white }}
            >
              <LuPhone size={18} color={T.lime} />
              <div>
                <p style={{ fontSize: "0.7rem", color: T.muted, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 2 }}>Teléfono</p>
                <p style={{ fontSize: "0.9rem" }}>{CONTACT_PHONE}</p>
              </div>
            </a>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
